import {Year} from './year.model';
import {CertificateOptionalGetting} from '../enums/certificate-optional-getting.enum';
import {PSchoolLevel} from '../param/p-school-level.model';


export class SchoolLevel {
    id: number;
    idPSchoolLevel: number;
    toSchool: boolean;
    schoolClass: string;
    schoolName: string;
    active: boolean;
    alternating: boolean;
    companyName: string;
    level?: string;
    formation: boolean;
    formationName: string;
    dateCreate: Date;
    dateUpdate: Date;
    years: Year;
    diplomeOptionnel: CertificateOptionalGetting;
    dateStart: Date;
    dateEnd: Date;

    pSchoolLevel: PSchoolLevel;
}
